import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Progress } from './progress.model';
import { ProgressService } from './progress.service';

@Injectable()
export class PartyListGuard implements Resolve<Progress> {

  constructor(private ProgressService: ProgressService) { }

  resolve(route: ActivatedRouteSnapshot) {
    return null;
    //this.ProgressService.getPartyList();
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/progress/party-list.guard.ts